export class LogsDto {
    // message: string;
    // timestamp : Date | any;
    userId:number;
    operationName:string;
    tableName:string;
    rowId:number;
    status:boolean;
    displayValue:string;
    createdUser: string;
    previousValue?:string;
    presentValue?:string;
    constructor(
      userId:number,
    operationName:string,
    tableName:string,
    rowId:number,
    status:boolean,
    displayValue:string,
    createdUser: string,
    previousValue?:string,
    presentValue?:string
    ){
      this.userId=userId;
      this.operationName=operationName;
      this.tableName=tableName;
      this.rowId=rowId;
      this.status=status;
      this.displayValue=displayValue;
      this.previousValue=previousValue;
      this.presentValue=presentValue;
      this.createdUser=createdUser

    }
  }
  

  